import { observable, makeObservable } from 'mobx';

class CompanyDocumentViewModel {
  uiState;
  companyDocument;
  checked = false;

  constructor(companyDocument, uiState) {
    makeObservable(this, {
      uiState: observable,
      companyDocument: observable,
      checked: observable
    });

    this.companyDocument = companyDocument;
    this.uiState = uiState;
  }
}

export default CompanyDocumentViewModel;
